import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class SellerService {
  baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) {}

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem("token");
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
  }

  // uploadContentFile(file) {
  //     return this.http.post(`${this.baseUrl}/api/uploadcontent`, file, { headers: this.getAuthHeaders() });
  // }

  uploadContentFile(file) {
    return this.http.post(`${this.baseUrl}/api/uploadcontent`, file, {
      headers: this.getAuthHeaders(),
    });
  }

  uploadImagesContent(file) {
    return this.http.post(`${this.baseUrl}/api/multiuploadcontent`, file, {
      headers: this.getAuthHeaders(),
    });
  }

  uploadFilesContent(file, progress) {
    return this.http.post(`${this.baseUrl}/api/multiuploadcontent`, file, {
      headers: this.getAuthHeaders(),
    });
  }

  uploadVideoFile(file, progress) {
    return this.http.post(`${this.baseUrl}/api/uploadcontent`, file, {
      headers: this.getAuthHeaders(),
    });
  }

  uploadContentFileForContent(file) {
    return this.http.post(`${this.baseUrl}/api/uploadcontent`, file, {
      headers: this.getAuthHeaders(),
    });
  }

  addSellerContent(content) {
    return this.http.post(`${this.baseUrl}/api/addcontent`, content, {
      headers: this.getAuthHeaders(),
    });
  }

  updateSellerContent(content) {
    return this.http.post(`${this.baseUrl}/api/updateContent`, content, {
      headers: this.getAuthHeaders(),
    });
  }

  getLibraryContent(sellerId, contentId, live) {
    return this.http.get(
      `${this.baseUrl}/api/contentlist?uid=${sellerId}&id=${contentId}&live=${live}`,
      { headers: this.getAuthHeaders() }
    );
  }

  getSellerContent(contentId) {
    return this.http.get(`${this.baseUrl}/api/contentlist?uid=${contentId}`, {
      headers: this.getAuthHeaders(),
    });
  }

  getSellerContentList(sellerId) {
    return this.http.get(`${this.baseUrl}/api/contentlist?uid=${sellerId}`, {
      headers: this.getAuthHeaders(),
    });
  }

  getSellerContentListLive(sellerId, live) {
    return this.http.get(
      `${this.baseUrl}/api/contentlist?uid=${sellerId}&live=${live}`,
      { headers: this.getAuthHeaders() }
    );
  }

  getSellerContentListLiveToken(sellerId: string, live: number) {
    return this.http.get(
      `${this.baseUrl}/api/contentlist?uid=${sellerId}&live=${live}`,
      { headers: this.getAuthHeaders() }
    );
  }

  getAllContentList() {
    return this.http.get(`${this.baseUrl}/api/contentlist`, {
      headers: this.getAuthHeaders(),
    });
  }

  getOffersList(
    sellerId: number,
    content_id: number = null,
    offer_id: number = null
  ) {
    return this.http.get(
      `${this.baseUrl}/api/getOfferByCustomer?uid=${sellerId}&content_id=${content_id}&offer_id=${offer_id}`,
      { headers: this.getAuthHeaders() }
    );
  }

  getCategoriesList() {
    return this.http.get(`${this.baseUrl}/api/getcategory`, {
      headers: this.getAuthHeaders(),
    });
  }

  buyerTagsList(tag) {
    return this.http.post(`${this.baseUrl}/api/getTag`, tag, {
      headers: this.getAuthHeaders(),
    });
  }

  sellerTagsList(tag) {
    // return this.http.post(`${this.baseUrl}/api/getTag`, tag, {
    //   headers: this.getAuthHeaders(),
    // });
     return this.http.post(`${this.baseUrl}/api/seller/getTag`, tag, {
      headers: this.getAuthHeaders(),
    });
  }

  sellerContentListUid(uid): Observable<any> {
    return this.http.get(`${this.baseUrl}/api/getBuyeroffer?uid=${uid}`, {
      headers: this.getAuthHeaders(),
    });
  }

  deleteContent(tag) {
    return this.http.post(`${this.baseUrl}/api/deleteContent`, tag, {
      headers: this.getAuthHeaders(),
    });
  }

  getNotifications(receiver_id): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/api/totalunread?receiver_id=${receiver_id}`,
      { headers: this.getAuthHeaders() }
    );
  }

  getBuyerNotiCount(receiver_id): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/api/total-unread-count?receiver_id=${receiver_id}`,
      { headers: this.getAuthHeaders() }
    );
  }

  addSellerCsvContent(val) {
    return this.http.post(`${this.baseUrl}/api/uploadcsvcontent`, val, {
      headers: this.getAuthHeaders(),
    });
  }

  csvBulk(uid) {
    return this.http.post(`${this.baseUrl}/api/csvprocesslist`, uid, {
      headers: this.getAuthHeaders(),
    });
  }

  callAddBulkMetadataCsv() {
    return this.http.get(`${this.baseUrl}/api/csvupload_get`, {
      headers: this.getAuthHeaders(),
    });
  }

  callAddBulkMetadataUpdateCsv() {
    return this.http.get(`${this.baseUrl}/api/csvupload_update`, {
      headers: this.getAuthHeaders(),
    });
  }

  getSellerMediaList(sellerId, type): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/api/getsellermedia?uid=${sellerId}&media_type=${type}`,
      { headers: this.getAuthHeaders() }
    );
  }

  mappingContentFile(file) {
    return this.http.post(`${this.baseUrl}/api/contentmap`, file, {
      headers: this.getAuthHeaders(),
    });
  }

  deleteContentFile(file) {
    return this.http.post(`${this.baseUrl}/api/contentdelete`, file, {
      headers: this.getAuthHeaders(),
    });
  }

  unmappingContentFile(file) {
    return this.http.post(`${this.baseUrl}/api/contentunmap`, file, {
      headers: this.getAuthHeaders(),
    });
  }

  uploadContentFileForSeries(data) {
    return this.http.post(`${this.baseUrl}/api/webseason`, data, {
      headers: this.getAuthHeaders(),
    });
  }

  uploadContentFileForEpisode(data) {
    return this.http.post(`${this.baseUrl}/api/webepisode`, data, {
      headers: this.getAuthHeaders(),
    });
  }

  uploadFileForSeries(data) {
    return this.http.post(`${this.baseUrl}/api/imgupload`, data, {
      headers: this.getAuthHeaders(),
    });
  }

  getAllOfferList(seller_id): Observable<any> {
    console.log(
      "Token used in uploadContentFile:",
      localStorage.getItem("token")
    );
    return this.http.get(
      `${this.baseUrl}/api/getAllSubmitOffer?seller_id=${seller_id}`,
      { headers: this.getAuthHeaders() }
    );
  }

  getSellerAllSeason(content_id, seller_id): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/api/allseason?content_id=${content_id}&seller_id=${seller_id}`,
      { headers: this.getAuthHeaders() }
    );
  }

  getSellerAllEpisode(content_id, seller_id, season) {
    return this.http.get(
      `${this.baseUrl}/api/allepisode?content_id=${content_id}&seller_id=${seller_id}&season=${season}`,
      { headers: this.getAuthHeaders() }
    );
  }

  resubmitOfferPage(data) {
    return this.http.post(`${this.baseUrl}/api/resubmitoffer`, data, {
      headers: this.getAuthHeaders(),
    });
  }

  offerHistoryPage(uid, offer_id) {
    return this.http.get(
      `${this.baseUrl}/api/offerhistory?offer_id=${offer_id}&uid=${uid}`,
      { headers: this.getAuthHeaders() }
    );
  }

  acceptOffer(seller_id, offer_id) {
    return this.http.get(
      `${this.baseUrl}/api/acceptoffer?offer_id=${offer_id}&uid=${seller_id}`,
      { headers: this.getAuthHeaders() }
    );
  }

  contactUSForm(data) {
    return this.http.post(`${this.baseUrl}/api/get-in-touch`, data, {
      headers: this.getAuthHeaders(),
    });
  }

  addHitListData(id) {
    return this.http.post(`${this.baseUrl}/api/updatedtrendingcontent`, id, {
      headers: this.getAuthHeaders(),
    });
  }

  addWatchlistData(data) {
    return this.http.post(`${this.baseUrl}/api/add-watch-list`, data, {
      headers: this.getAuthHeaders(),
    });
  }

  getWatchListData(seller_id) {
    return this.http.get(`${this.baseUrl}/api/get-watch-list?id=${seller_id}`, {
      headers: this.getAuthHeaders(),
    });
  }

  deleteWatchList(tag) {
    return this.http.post(`${this.baseUrl}/api/deletewatchlistcontent`, tag, {
      headers: this.getAuthHeaders(),
    });
  }

  getLibraryDataCheck(uid) {
    return this.http.get(`${this.baseUrl}/api/getlibraryalldata?uid=${uid}`, {
      headers: this.getAuthHeaders(),
    });
  }

  getLibraryDataList(uid, type) {
    return this.http.get(
      `${this.baseUrl}/api/getlibrarycontent/?uid=${uid}&content_type=${type}`,
      { headers: this.getAuthHeaders() }
    );
  }

  addLibraryDataList(data) {
    return this.http.post(`${this.baseUrl}/api/addlibrarycontent/`, data, {
      headers: this.getAuthHeaders(),
    });
  }

  uploadLibrarytrailer(file) {
    return this.http.post(`${this.baseUrl}/api/uploadlabcontent`, file, {
      headers: this.getAuthHeaders(),
    });
  }

  updateLibraryDataList(file) {
    return this.http.post(`${this.baseUrl}/api/updatelibrarydata`, file, {
      headers: this.getAuthHeaders(),
    });
  }

  getLibraryAllDataList(uid) {
    return this.http.get(`${this.baseUrl}/api/getlibrarydata?uid=${uid}`, {
      headers: this.getAuthHeaders(),
    });
  }

  deleteLibrary(id) {
    return this.http.get(`${this.baseUrl}/api/deletelibrarydata/?id=${id}`, {
      headers: this.getAuthHeaders(),
    });
  }

  getOMDBSearchYearApiData(x: any, y: any, z: any) {
    return this.http.get(
      `https://www.omdbapi.com/?apikey=5dfdedb&s=${x}&y=${y}&type=${z}`
    );
  }

  getOMDBApiDataByID(id: any) {
    return this.http.get(`https://www.omdbapi.com/?apikey=5dfdedb&i=${id}`);
  }

  woohooList(uid: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/api/woolist/?uid=${uid}`, {
      headers: this.getAuthHeaders(),
    });
  }

  updateWoohoo(uid: number, ides: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/api/update_woo/?uid=${uid}&ids=${ides}`,
      { headers: this.getAuthHeaders() }
    );
  }

}
